function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChrome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M155.217 314.173 256 139.621l18.717.321 30.593 1.179 102.195 35.376 76.571-36.876C441.7 56.74 355.477 0 256 0 165.638 0 86.216 46.821 40.657 117.523v.172l7.746 131.034 106.814 65.444z",
    style: {},
    fill: "#db4437",
    "data-original": "#db4437",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.217 314.173 40.657 117.695l-.053-.091C14.911 157.509 0 205.012 0 256c0 137.319 108.12 249.374 243.873 255.707l91.484-60.672 21.407-136.828-201.547-.034z",
    style: {},
    fill: "#0f9d58",
    "data-original": "#0f9d58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.076 139.621H256l100.783 174.552-.019.034-112.891 197.5.089.003c3.991.185 8.002.29 12.039.29 141.385 0 256-114.615 256-256-.001-41.908-10.073-81.463-27.925-116.379z",
    style: {},
    fill: "#ffcd40",
    "data-original": "#ffcd40"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 116.379,
    style: {},
    fill: "#f1f1f1",
    "data-original": "#f1f1f1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 93.103,
    style: {},
    fill: "#4285f4",
    "data-original": "#4285f4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChrome);
export default __webpack_public_path__ + "static/media/chrome.9764f578fa7363c82133e44001d0e28f.svg";
export { ForwardRef as ReactComponent };